import { useEffect, useState,useContext } from 'react';
import { useMemberIDCard } from '@sentara-health/sentara-api-hooks-core';
import MemberIdCardFax from './MemberIdCardFax';
import MemberIdCardTable from './MemberIdCardTable';
import { errorhandler } from 'common';
import { Loader, GlobalError, Headings } from '@sentara-health/optimahealth_web';
import { GlobalContext } from 'context';
import { useTranslation } from 'react-i18next';
// Define the MembreIdCard component
function MemberIdCard() {
  const { t } = useTranslation();

  const { getFeature
  } = useContext(GlobalContext);
 //  Initialize useTranslation hook
  const [loading, setLoading] = useState<any>(false);
  // Initializing the memberIDCardType hook to fetch member ID card data
  const { memberIDCardType } = useMemberIDCard();
  //  idCard to store the member ID card data 
  const [idCard, setIdCard] = useState<any>();
  // to track whether the model is open or not
  const [isOpen, setIsOpen] = useState(false);
  // to track whether the fax modal is open or not
  const [isOpenFax, setIsOpenFax] = useState(false);
  const [dependentMemberError, setDependentMemberError] = useState<boolean>(false);
  // Manages the visibility of buttons
  const [showBtn, setShowBtn] = useState<any>([]);

  //Function to fetch member ID card data list
  async function asyncCall() {
    const result = await memberIDCardType('memberidcard');
    if (result?.data !== null && result?.data !== undefined) {
      setIdCard(result?.data);
    } else if (result?.errorCode) {
      setDependentMemberError(true);
      errorhandler(result?.errorCode);
    }
    setLoading(false);
  }

  // Fetch member ID card data on component mount
  useEffect(() => {
    setLoading(true);
    asyncCall();
  }, []);

  // Render the MemberIdCard component
  return (
    <>
      {loading && <Loader />}
      <div className="my_plan_provider member_id_card">
        <div className="mb-4">
          <Headings
            level={1}
            text={t('common.memberIDCard')}
            variant="semiBold"
            dataTestId="memberIdCardHeader"
          />          
        </div>
        {dependentMemberError ? (
          <GlobalError variant="mb-3" dataTestId="memberIdCardError">
            {t('yourPlan.memberIdCardError')}
          </GlobalError>
        ) : (
        <MemberIdCardTable
          mapState={idCard?.members}
          setIsOpenFax={() => {
            setIsOpenFax(true);
            setIsOpen(true);
          }}
          setShowBtn={setShowBtn}
          showBtn={showBtn}
          OrderMemberIDCard={getFeature?.OrderMemberIDCard}
          faxIDCard={getFeature?.faxIDCard}
        />
        )}
        {isOpenFax && (
          <MemberIdCardFax
            isOpen={isOpen}
            setIsOpen={() => setIsOpen(false)}
            setIsOpenFax={() => {
              setIsOpenFax(true);
              setIsOpen(true);
            }}
          />
        )}
      </div>
    </>
  );
}
export default MemberIdCard;
